export const commonSlice = (set) => ({
	loading: false,
	requestBody: {},
	setLoading: (loading) => set({ loading }),
	setRequestBody: (requestBody) => set({ requestBody }),
});
